import React, { useState } from "react";

// import JS files

const CreateOrderCard = ({ children, ring }) => {
  return (
    <>
      <div className="grid md:grid-cols-5">
        <div className="md:col-span-1 text-sm flex justify-center items-center mb-4 md:mb-0">
          <span className="text-myblue-100">{ring.code}</span>/
          <span className="text-myblue-100">{ring.show_name}</span>/
          <span className="text-myblue-100">{ring.brand_name}</span>/
          <span className="bg-slate-100 rounded-lg py-1 px-2">
            {ring.gender == "girl" ? "بچه گانه" : "زنانه"}
          </span>
          /
          {ring.color == "yellow" ? (
            <span className="bg-yellow-400 rounded-lg py-1 px-2">زرد</span>
          ) : (
            <span className="bg-slate-50 border border-slate-200 rounded-lg py-1 px-2">
              سفید
            </span>
          )}
        </div>
        <div className="md:col-span-4">{children}</div>
      </div>
    </>
  );
};

export default CreateOrderCard;
